import { Card, Skeleton, Text } from '@mantine/core'

import { useQueryGetInquiryById } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'

import { TableInquiryProductsReadOnly } from '../TableInquiryProductsReadOnly/TableInquiryProductsReadOnly'

export type CardInquiryProductsProps = {
  inquiryId: number
}

export function CardInquiryProducts({ inquiryId }: CardInquiryProductsProps) {
  const { data, isLoading: loading } = useQueryGetInquiryById({ inquiryId })
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const inquiry = data?.inquiry

  return (
    <Card>
      <Text fw={500} mb='xs'>{t('articles_title')}</Text>
      {loading ? (
        <Skeleton data-testid='loading' />
      ) : (
        <TableInquiryProductsReadOnly
          withBorder={false}
          inquiryProducts={inquiry?.inquiry_products}
        />
      )}
    </Card>
  )
}
